module.exports = __webpack_public_path__ + "img/spray.0a7248a8.png";